import React from 'react';
import { Colors } from 'library';
import { RModal, RModalFooter, RPillButton, RStack, RText } from 'recruit/components';
import { PaymentMethod } from './types';

interface DeleteConfirmModalProps {
    method: PaymentMethod;
    submitting: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

export function DeleteConfirmModal({ method, submitting, onCancel, onConfirm }: DeleteConfirmModalProps) {
    const affected = method.affected_business_locations;
    const title = affected.length > 0 ? 'Delete payment method?' : 'Confirm Delete';

    return (
        <RModal title={title} onClose={() => !submitting && onCancel()} width={460}>
            <RStack gap="md">
                <RText>Are you sure you want to remove this payment method?</RText>
                {affected.length > 0 && (
                    <RStack gap="sm">
                        <RText weight="semibold">
                            {affected.length === 1
                                ? 'This location will use your default payment method instead:'
                                : 'These locations will use your default payment method instead:'}
                        </RText>
                        <RStack gap="sm">
                            {affected.map((loc) => (
                                <RText key={loc.id} size="sm">
                                    • {loc.name ?? `Location ${loc.id}`}
                                </RText>
                            ))}
                        </RStack>
                    </RStack>
                )}
                <RModalFooter>
                    <RPillButton variant="secondary" onClick={onCancel} disabled={submitting}>
                        Cancel
                    </RPillButton>
                    <RPillButton onClick={onConfirm} disabled={submitting} color={Colors.mediumRed}>
                        {submitting ? 'Deleting…' : 'Delete'}
                    </RPillButton>
                </RModalFooter>
            </RStack>
        </RModal>
    );
}
